<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-freckle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.737 45.965A.999.999 0 0023 46h2c.091 0 .18-.012.262-.036C36.825 45.31 46 35.727 46 24c0-11.726-9.175-21.31-20.737-21.965A1 1 0 0025 2h-2a.967.967 0 00-.262.036C11.175 2.69 2 12.274 2 24c0 11.727 9.175 21.31 20.737 21.965zm-.736-4.075C13 40.896 6 33.265 6 24S13 7.104 22 6.11v35.78zm4 0C35 40.895 42 33.265 42 24S35 7.105 26 6.11v35.78zM35 31a3 3 0 10-6 0 3 3 0 006 0zm-6-11a2 2 0 110 4 2 2 0 010-4zm8-4a3 3 0 10-6 0 3 3 0 006 0z"/></svg>
</template>
<script>

export default {
  name: 'IconFreckle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
